export default __webpack_public_path__ + "static/media/dotnet.fba2499f.png";